import { create } from 'zustand'
import { Language } from '@/types/language.types'

/** Pre-computed paths for each language, e.g., { en: '/offers/my-offer', se: '/erbjudanden/mitt-erbjudande' } */
export type AlternateUrls = Record<Language, string | null>

type AlternateSlugsStore = {
  /** The pre-computed alternate URLs for the current page, keyed by language */
  alternateUrls: AlternateUrls | null
  /** Set the alternate URLs for the current page */
  setAlternateUrls: (urls: AlternateUrls) => void
  /** Clear the alternate URLs (call on page unmount) */
  clearAlternateUrls: () => void
}

export const useAlternateSlugsStore = create<AlternateSlugsStore>()((set) => ({
  alternateUrls: null,
  setAlternateUrls: (alternateUrls) => set({ alternateUrls }),
  clearAlternateUrls: () => set({ alternateUrls: null }),
}))
